// extracted by mini-css-extract-plugin
export default {"ordinalNumber":"Contacts_ordinalNumber__s4B2f"};